import { DASHBOARD } from "../actionTypes";
import { _getLivePulse } from "../../controllers";

export const getLivePulse = (objPayload) => async (dispatch) => {

    const objResp = await _getLivePulse(objPayload)

    if (objResp?.status) {
        dispatch(getLivePulseSuccess(objResp?.data));
    } else {
        dispatch(getLivePulseSuccess([]));
    }
};

export const getLivePulseSuccess = (payload) => {
    return { type: DASHBOARD.GET_LIVE_PULSE, payload: payload };
};